import { Component, OnInit, OnDestroy, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { Constants } from 'src/app/shared/constants';
import { WebStorageService } from 'src/app/shared/services/web-storage.service';
import { forkJoin, fromEvent, Subject } from 'rxjs';
import { SafeUrl } from '@angular/platform-browser';
import { finalize, takeUntil } from 'rxjs/operators';
import { CustomSettingsResponseModel } from 'src/app/shared/models/response/settings-response';
import { BranchInfoContactModel } from '../../shared/models/response/sales-order-current';
import { Router } from '@angular/router';
import { AppointmentInfoReponseModel } from 'src/app/shared/models/response/appointment/appointment-info-reponse-model';
import { SalesOrderInfoResponseModel } from 'src/app/shared/models/response/appointment/sales-order-info-reponse-model';
import { SalesOrderResponseModel } from 'src/app/shared/models/response/sales-order-response';
import { PatientService } from '../services/patient.service';
import { TimezonePipe } from 'src/app/pipes/timezone.pipe';
import { AppointmentCancelRequest } from 'src/app/shared/models/request/appointment-cancel-request';
import { ResultOfT } from 'src/app/shared/models/response/result';
import { WipStatusBTmapping } from 'src/app/shared/models/common/wip-status';
import { PatientSettingsService } from '../services/patient-settings.service';
import { BTSalesOrderUpdateRequestModel } from 'src/app/shared/models/request/salesorder-update-request-model-brightree';
import moment from 'moment';
import { BranchNumbersResponseModel } from 'src/app/shared/models/response/branch-numbers-response-model';
import {
  SalesOrderHistoryCountModel,
  SelfSchedulingConfigModel,
  SelfSchedulingGeneralSetupModel,
  SelfSchedulingWrapper
} from 'src/app/shared/models/response/settings/self-scheduling-config-model';
import { SelfSchedulingConfigService } from 'src/app/admin/servicies/self-scheduling-config-service';
import { google, outlook, yahoo } from 'calendar-link';
import { WipStatusBtService } from 'src/app/services/wip-status-bt.service';
import { marker } from 'src/app/interfaces/marker';
import { PaymentService } from 'src/app/shared/services/payment.service';
import { AdminSettingsService } from 'src/app/admin/servicies/admin-settings.service';
import { PaymentSetupRequestModel } from 'src/app/interfaces/payment-integration';
import { ApplicableFor, PaymentFlowType } from 'src/app/interfaces/payment-enums';
import { CollectPaymentComponent } from 'src/app/shared/collect-payment/collect-payment.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { PaymentResponseModel } from 'src/app/interfaces/payment-response';
import { CancelFeesInfo } from 'src/app/interfaces/cancel-fees-info';
import { PaymentInformationModel } from 'src/app/interfaces/payment-information';
import { PaymentTransaction } from 'src/app/interfaces/recent-patient-transaction';
import nextbillion, { Map, Marker, NBMap, LngLatBounds, Popup } from '@nbai/nbmap-gl';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-reschedule-appointment',
  templateUrl: './reschedule-appointment.component.html',
  styleUrls: ['./reschedule-appointment.component.sass'],
  standalone: false
})
export class RescheduleAppointmentComponent extends BaseComponent implements OnInit, OnDestroy {
  public googleCalendarEventUrl: SafeUrl;

  selectedName: { name: string; code: string };
  appointmentStartDate: string | number | Date;
  durationInMinutes: number;
  appointmentEndDate: string | number | Date;
  description: string;
  zoom: number = 8;
  RescheduleAppointment: boolean = false;
  CancelAppointment: boolean = false;
  Addtocalendar: { name: string; code: string }[];
  patientBookingTypeId: string;
  showFacilityAddress: boolean;
  isTherapistRemoteType: any;
  loading: boolean;
  private progress = new Subject<boolean>();
  private unsubscriber = new Subject<boolean>();
  appointment: AppointmentInfoReponseModel;
  salesOrder: SalesOrderInfoResponseModel;
  scheduledApptDuration: string;
  patientName: string = '';
  patientEmail: string = '';
  patientPhone: string = '';
  patientMobileNumber: string = '';
  patientLatitude: number;
  patientLongitude: number;
  patientAddress: string;
  dueAmount: number;
  schAppointmentId: number;
  appointmentType: string = '';
  dateFormat: string;
  salesOrderData: SalesOrderResponseModel;
  therapistName: string = '';
  facilityName: string = '';
  facilityAddress: string = '';
  facilityLatitude: number;
  facilityLongitude: number;
  distance: string = '';
  patientTimezone: string;
  wipStatusBTMappingResponseModel: WipStatusBTmapping[];
  isAllowToCancelAppointment: boolean = true;
  DMENumber: string;
  markers: marker[] = [];
  bookAppointmentLabelName: string = 'Book Your Appointment';
  cancelnote: string;
  ShowDueAmount: boolean = false;
  ShowDeliveryNote: boolean = false;
  appointmentTitle: string = '';
  isBranchAllowSelfScheduleAppointments: boolean = false;
  settingResult: CustomSettingsResponseModel;
  ShowRescheduleButton: boolean = false;
  ShowCancelButton: boolean = false;
  paymentIntegrationSetting: any;
  paymentResponseModel: PaymentResponseModel | null = null;
  hasExistingCard: boolean = false;
  model = {} as SelfSchedulingWrapper;
  modelConfig = {} as SelfSchedulingConfigModel;
  modelsetup = {} as SelfSchedulingGeneralSetupModel;
  cancelFeesInfo: CancelFeesInfo;
  paymentInfo: PaymentInformationModel;
  lastPayment: PaymentTransaction;
  @ViewChild('mapContainer', { static: false }) mapContainer!: ElementRef;
  map!: Map;
  key: string = environment.nextBillionApiKey;
  isPaymentApplicable = this.webStorageService.getIsPaymentApplicable();

  constructor(
    messageService: MessageService,
    private webStorageService: WebStorageService,
    private patientService: PatientService,
    private patientSettingsService: PatientSettingsService,
    private configService: SelfSchedulingConfigService,
    private settingsService: AdminSettingsService,
    private router: Router,
    private wipStatusBtService: WipStatusBtService,
    private paymentService: PaymentService,
    private dialogService: DialogService
  ) {
    super(messageService);
    this.salesOrderData = this.webStorageService.getSalesOrderData();
    this.DMENumber = this.webStorageService.getDMENumber();
  }


  private initMap() {
    if (!this.mapContainer?.nativeElement) {
      console.error('Map container not available');
      return;
    }

    try {
      nextbillion.setApiKey(this.key);

      this.map = new Map({
        container: this.mapContainer.nativeElement,
        style: `https://api.nextbillion.io/maps/streets/style.json?key=${this.key}`,
        zoom: 7,
        attributionControl: false,
        center: {
          lat: this.facilityLatitude || 34.08572,
          lng: this.facilityLongitude || -118.124569
        }
      });

      this.map.on('load', () => {
        console.log('Map loaded successfully');
        this.addCustomMarkerWithDom(this.map);
      });

      this.map.on('error', (error) => {
        console.error('Map error:', error);
      });

    } catch (error) {
      console.error('Error initializing map:', error);
    }
  }

  addCustomMarkerWithDom(map: Map) {
    if (!map) {
      console.error('Map instance not provided');
      return;
    }

    const createMarkerElement = (label: string, bgColor: string = '#ff4444'): HTMLElement => {
      const el = document.createElement('div');
      el.className = 'marker';
      el.style.backgroundColor = bgColor;
      el.style.color = 'white';
      el.style.borderRadius = '50%';
      el.style.width = '36px';
      el.style.height = '36px';
      el.style.display = 'flex';
      el.style.alignItems = 'center';
      el.style.justifyContent = 'center';
      el.style.fontSize = '16px';
      el.style.fontWeight = 'bold';
      el.style.border = '2px solid white';
      el.style.boxShadow = '0 2px 4px rgba(0,0,0,0.3)';
      el.innerHTML = label;
      return el;
    };

    const markersData = [
      { lat: this.facilityLatitude, lng: this.facilityLongitude, label: 'F', popupText: 'Facility' },
      { lat: this.patientLatitude, lng: this.patientLongitude, label: 'P', popupText: 'Patient' }
    ];

    const bounds = new LngLatBounds();

    markersData.forEach(m => {
      try {
        const popup = new Popup({ offset: 10, closeButton: false }).setText(m.popupText);
        const markerEl = createMarkerElement(m.label);
        const marker = new Marker({ element: markerEl })
          .setLngLat({ lat: m.lat, lng: m.lng })
          .setPopup(popup)
          .addTo(map);

        marker.togglePopup();
        bounds.extend([m.lng, m.lat]);
      } catch (error) {
        console.error('Error adding marker:', error, m);
      }
    });

    // Fit bounds only if we have valid bounds
    try {
      if (!bounds.isEmpty()) {
        map.fitBounds(bounds, { padding: 50 });
      }
    } catch (error) {
      console.error('Error fitting bounds:', error);
    }
  }


  async ngOnInit() {
    history.pushState(null, '');
    this.loadData();
    await this.getLastPaymentInfo();
    this.paymentInfo = await this.getPaymentInformation();

    fromEvent(window, 'popstate')
      .pipe(takeUntil(this.unsubscriber))
      .subscribe((_) => {
        history.pushState(null, '');
      });
    if (!this.DMENumber) {
      this.getDMENumber();
    }
    this.Addtocalendar = [
      { name: 'Select Calendar', code: 'S' },
      { name: 'Google', code: 'G' },
      { name: 'Yahoo', code: 'Y' },
      { name: 'Outlook', code: 'O' }
    ];

    this.schAppointmentId = this.salesOrderData?.schAppointmentId;

    this.settingResult = this.webStorageService.getPatientSalesOrderSettings();
    if (this.settingResult == undefined || this.settingResult == null) {
      this.GetPatientSalesOrdersSetings();
    }

    if (this.settingResult) {
      this.dateFormat = this.settingResult.dateFormat;
      if (this.settingResult.showDueAmount.toLowerCase() === 'true') this.ShowDueAmount = true;
      else this.ShowDueAmount = false;

      if (this.settingResult.showDeliveryNote.toLowerCase() === 'true') this.ShowDeliveryNote = true;
      else this.ShowDeliveryNote = false;
    }

    this.isAllowToCancelAppointment = this.salesOrderData?.crmSalesorderStatus.toLowerCase() === Constants.booked ? true : false; // && isCancellationAllowed....
    if (this.isAllowToCancelAppointment) this.bookAppointmentLabelName = 'Reschedule Appointment';
    else this.bookAppointmentLabelName = 'Book Your Appointment';
    if (this.schAppointmentId == 0) {
      this.patientName = this.salesOrderData.patientInfo.crmPatientFirstName + ' ' + this.salesOrderData.patientInfo.crmPatientLastName;
      if (this.salesOrderData.patientInfo.crmPatientEmailAddress) {
        this.patientEmail = this.salesOrderData.patientInfo.crmPatientEmailAddress;
      } else {
        this.patientEmail = '';
      }
      if (this.salesOrderData.patientInfo.crmPatientPhoneNo) {
        this.patientPhone = this.salesOrderData.patientInfo.crmPatientPhoneNo;
      } else {
        this.patientPhone = '';
      }
      if (this.salesOrderData.patientInfo.crmPatientMobileNumber) {
        this.patientMobileNumber = this.salesOrderData.patientInfo.crmPatientMobileNumber;
      } else {
        this.patientMobileNumber = '';
      }
    } else {
      this.getAppointmentInfo(this.schAppointmentId);
    }
    this.getWipStatusBTmapping();

    this.paymentService.paymentCompletedPatient$.pipe(takeUntil(this.unsubscriber)).subscribe((paymentResponse) => {
      if (paymentResponse && paymentResponse.isSuccess) {
        this.paymentResponseModel = paymentResponse;
      }
    });

  }

  async loadData() {
    this.loading = true;

    try {
      const [historyResult, configResult] = await forkJoin([
        this.configService.getSalesorderHistoryCount(this.salesOrderData.crmSalesorderId),
        this.configService.getAll()
      ]).toPromise();

      let salesOrderHistoryCountModel = new SalesOrderHistoryCountModel();
      this.processResult<SalesOrderHistoryCountModel>(historyResult, () => {
        if (historyResult.isSuccess && historyResult.responseModel) {
          salesOrderHistoryCountModel = historyResult.responseModel;
        }
      });

      this.model = configResult.responseModel;

      let branch = false,
        classification = false,
        insurance = false;
      this.modelConfig = null;
      this.model.configs.forEach((element) => {
        if (!element.isDefault) {
          branch = element?.jsonValue?.branchIds?.split(',').includes(this.salesOrderData?.crmBranchId.toString());
          classification = element?.jsonValue?.classificationIds?.split(',').includes(this.salesOrderData?.crmSalesorderClassificationType.toString());
          const insuranceIds = element?.jsonValue?.insuranceIds?.split(',');
          insurance = insuranceIds?.some((id) => this.salesOrderData?.salesOrderInsuranceInfo?.some((info) => info.crmPolicyHolderName.toString() === id));

          if (branch && classification && insurance) {
            this.modelConfig = element;
            return;
          }
        }
      });
      this.modelsetup = this.model.setup;
      if (this.modelsetup?.isEnabled && this.modelConfig == null) {
        this.modelConfig = this.model.configs.find((x) => x.isDefault);
      }

      this.ShowCancelButton =
        this.modelConfig?.jsonValue?.isCancellationAllowed &&
        (!this.modelConfig?.jsonValue?.isLimitNoOfCancelAppointments || salesOrderHistoryCountModel?.canceledCount < this.modelConfig?.jsonValue?.maxCancelAllowed);

      this.ShowRescheduleButton =
        this.modelConfig?.jsonValue?.isRescheduleAllowed &&
        (!this.modelConfig?.jsonValue?.isLimitNoOfRescheduleAppointments ||
          salesOrderHistoryCountModel?.rescheduleCount < this.modelConfig?.jsonValue?.maxRescheduleAllowed);

      this.loading = false;
    } catch (error) {
      this.loading = false;
      this.showErrorMessage(error.message);
    }
  }

  onEventClick() {
    if (this.selectedName.code === 'S') {
      return;
    }
    const event = {
      title: 'Appointment booked',
      description: this.description,
      start: new Date(this.appointmentStartDate),
      end: new Date(this.appointmentEndDate),
      duration: [this.durationInMinutes, 'minute'] as [number, 'second' | 'minute' | 'hour' | 'day'],
      location: this.facilityAddress
    };

    let googleLink = google(event);
    let yahooLink = yahoo(event);
    let outlookLink = outlook(event);

    setTimeout(() => {
      if (this.selectedName.code === 'G') {
        window.open(googleLink, '_blank');
      } else if (this.selectedName.code === 'O') {
        window.open(outlookLink, '_blank');
      } else if (this.selectedName.code === 'Y') {
        window.open(yahooLink, '_blank');
      }
    }, 0);
  }

  ngOnDestroy() {
    if (this.unsubscriber) {
      this.unsubscriber.next();
      this.unsubscriber.complete();
    }
    if (this.progress) this.progress.complete();
  }

  onBack() {
    let url = this.webStorageService.getPatientBookingUrl().split('?')[0].split('home/')[1];
    this.router.navigate(['/patient/home/' + url], { queryParams: { utm_source: 'rescheduleappointment' } });
  }

  onCancel() {
    this.paymentService.paymentCompletedPatient$.next(null);
    if (this.cancelFeesInfo?.chargeCancelFees && this.cancelFeesInfo?.amount > 0) {
      this.handleCancellationWithFee();
    }
    else {
      this.processCancellation();
    }
  }

  private async handleCancellationWithFee() {
    this.loading = true;
    try {
      this.paymentInfo = await this.getPaymentInformation();
      this.hasExistingCard = this.paymentInfo?.paymentCard !== null;
      await this.openPaymentDialog();
    } catch (error) {
      this.loading = false;
      this.showErrorMessage('Failed to process cancellation fee. Please try again.');
    }
  }

  private openPaymentDialog() {
    let dialogRef: DynamicDialogRef;
    const requestData: PaymentSetupRequestModel = {
      salesOrderId: this.salesOrderData.crmSalesorderId,
      appointmentCancelRequest: this.buildCancelRequestModel(),
      flowType: PaymentFlowType.CancelFees,
      applicableFor: ApplicableFor.Patient
    };

    dialogRef = this.dialogService.open(CollectPaymentComponent, {
      header: 'Cancellation Fee Payment',
      width: '700px',
      height: '80%',
      modal: true,
      closable: true,
      data: {
        ...requestData
      },
      styleClass: 'cancellation-fee-dialog'
    });

    dialogRef.onClose.subscribe((response: PaymentResponseModel) => {
      if (response && response?.isSuccess && (response?.paymentFlowType === PaymentFlowType.CancelFees)) {
        this.CancelAppointment = false;
        this.webStorageService.deleteAppointmentId();
        this.router.navigate(['/patient/booked-appointment']);

      }
      const paymentSetup = this.webStorageService.getPaymentSetup();
      if (paymentSetup) {
        this.paymentService.clearPaymentSetup(paymentSetup).subscribe(() => {
          this.webStorageService.deletePaymentSetup();
        });
      }
    });
  }

  private async getPaymentInformation(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.paymentService.getPaymentInformation(this.salesOrderData.crmSalesorderId).subscribe({
        next: (result) => resolve(result.responseModel),
        error: (error) => reject(error)
      });
    });
  }


  async getLastPaymentInfo() {
    this.loading = true;
    await this.patientService.getLastPaymentInfo(this.salesOrderData.crmSalesorderId)
      .pipe(
        takeUntil(this.unsubscriber),
        finalize(() => (this.loading = false))
      )
      .toPromise()
      .then((result) => {
        this.processResult<PaymentTransaction>(result, () => {
          if (result.isSuccess) {
            if (result.responseModel) {
              this.lastPayment = result.responseModel;

              if (!this.paymentResponseModel) {
                this.paymentResponseModel = {} as PaymentResponseModel;
              }

              this.paymentResponseModel.chargedAmount = this.lastPayment?.approvedAmount;
              this.paymentResponseModel.transactionID = this.lastPayment?.transactionID;
              this.paymentResponseModel.isSuccess = true;
            }
          }
        });
      }, error => {
        this.loading = false;
        this.showErrorMessage(error.message);
      });
  }

  private buildCancelRequestModel(): AppointmentCancelRequest {
    const cancelRequestModel = new AppointmentCancelRequest();
    cancelRequestModel.modifiedByUserInfoId = this.salesOrderData.patientInfo.crmPatientId;
    cancelRequestModel.schAppointmentId = this.salesOrderData.schAppointmentId;
    cancelRequestModel.schCancelReason = 'Other';
    cancelRequestModel.schComments = this.cancelnote;
    let cancelAppointmentRequestBT = new BTSalesOrderUpdateRequestModel();
    cancelAppointmentRequestBT.IsUpdateToBrightree = false;
    cancelAppointmentRequestBT.IsDeliveryNoteOverride = true;
    cancelAppointmentRequestBT.IsOrderNoteOverride = true;
    cancelAppointmentRequestBT.OrderNote = null;
    cancelAppointmentRequestBT.DeliveryNote = null;
    cancelAppointmentRequestBT.PractitionerName = null;
    cancelAppointmentRequestBT.PractitionerId = 0;
    cancelAppointmentRequestBT.ScheduledDeliveryStartDateString = null;
    cancelAppointmentRequestBT.ScheduledDeliveryStartTimeString = null;
    cancelAppointmentRequestBT.ScheduledDeliveryStartDate = null;
    cancelAppointmentRequestBT.WIPDateNeededString = moment().toDate().toDateString();
    cancelAppointmentRequestBT.WIPDateNeeded = moment().toDate();
    if (this.wipStatusBTMappingResponseModel != null && this.wipStatusBTMappingResponseModel != undefined) {
      let selectedWipStaus = this.wipStatusBTMappingResponseModel.find((x) => x.crmWipstatusNameSa.toLowerCase() == 'cancel');
      if (selectedWipStaus) {
        cancelAppointmentRequestBT.WIPStateName = selectedWipStaus.crmWipstatusNameBt;
        cancelAppointmentRequestBT.WIPStateKey = selectedWipStaus.wipStatusRCMId;
        cancelAppointmentRequestBT.IsUpdateToBrightree = selectedWipStaus.crmIsUpdateToBrigthree;
        cancelAppointmentRequestBT.WIPAssignedToKey = selectedWipStaus.crmWIPAssignedToKey;
      }
    }

    cancelRequestModel.salesOrderUpdateRequestModelBT = cancelAppointmentRequestBT;
    cancelRequestModel.isCancelledByPatient = true;
    return cancelRequestModel;
  }

  private processCancellation() {
    this.loadingCustom = true;
    this.CancelAppointment = false;
    this.loading = true;
    this.patientService
      .CancelAppointment(this.buildCancelRequestModel())
      .pipe(
        takeUntil(this.unsubscriber),
        finalize(() => (this.loading = false))
      )
      .subscribe((result) => {
        if (result.responseModel) {
          this.webStorageService.deleteAppointmentId();
          this.showSuccessMessage('Appointment has been canceled.');
          this.loadingCustom = false;
          let url = this.webStorageService.getPatientBookingUrl().split('?')[0].split('home/')[1];
          this.router.navigate(['/patient/home/' + url], { queryParams: { utm_source: 'email' } });
        } else {
          this.loadingCustom = false;
          if (result.message) this.showErrorMessage(result.message);
          else this.showErrorMessage('There was problem in cancelling your appointment.');
        }
      });
  }

  async getWipStatusBTmapping() {
    this.loading = true;
    this.wipStatusBtService
      .getMappings()
      .pipe(
        takeUntil(this.unsubscriber),
        finalize(() => (this.loading = false))
      )
      .subscribe(
        (result: ResultOfT<any>) => {
          this.processResult<any>(result, () => {
            if (result && result.isSuccess) {
              if (result.responseModel != undefined && result.responseModel != null) {
                this.wipStatusBTMappingResponseModel = result.responseModel;
              }
            }
          });
        },
        (httpResponseError) => {
          this.showErrorMessage(httpResponseError.message);
        }
      );
  }

  rescheduleAppointmentBtn() {
    this.paymentService.paymentCompletedPatient$.next(null);
    this.RescheduleAppointment = true;
  }

  async cancelAppointmentBtn() {
    this.loading = true;
    await this.patientService.GetCancelFeesInfo(this.schAppointmentId)
      .pipe(
        takeUntil(this.unsubscriber),
        finalize(() => (this.loading = false))
      )
      .toPromise()
      .then((result) => {
        this.processResult<CancelFeesInfo>(result, () => {
          if (result.isSuccess) {
            if (result.responseModel) {
              this.cancelFeesInfo = result.responseModel;
              this.CancelAppointment = true;
            }
          }
        });
      }, error => {
        this.loading = false;
        this.showErrorMessage(error.message);
      });
  }

  private getAppointmentInfo(AppoinmentId) {
    this.loadingCustom = true;
    this.loading = true;
    this.progress.next(true);
    this.patientService
      .GetAppointmentById(AppoinmentId)
      .pipe(
        takeUntil(this.unsubscriber),
        finalize(() => this.progress.next(false))
      )
      .toPromise()
      .then((result) => {
        this.processResult<AppointmentInfoReponseModel>(result, () => {
          if (result.isSuccess) {
            if (result.responseModel != undefined && result.responseModel != null) {
              this.appointment = result.responseModel;
              this.salesOrder = result.responseModel.salesOrderInfo;
              this.isBranchAllowSelfScheduleAppointments = this.appointment.crmBranchIsAllowSelfScheduleAppointments;
              this.scheduledApptDuration =
                this.appointment.schAppointmentDuration == 60 || this.appointment.schAppointmentDuration == 1
                  ? '1 Hour'
                  : this.appointment.schAppointmentDuration.toString() + ' Minutes';
              this.patientName = this.salesOrder.patientInfo.crmPatientFirstName + ' ' + this.salesOrder.patientInfo.crmPatientLastName;
              if (this.salesOrder.patientInfo.crmPatientEmailAddress) {
                this.patientEmail = this.salesOrder.patientInfo.crmPatientEmailAddress;
              } else {
                this.patientEmail = '';
              }
              if (this.salesOrder.patientInfo.crmPatientPhoneNo) {
                this.patientPhone = this.salesOrder.patientInfo.crmPatientPhoneNo;
              } else {
                this.patientPhone = '';
              }
              if (this.salesOrder.patientInfo.crmPatientMobileNumber) {
                this.patientMobileNumber = this.salesOrder.patientInfo.crmPatientMobileNumber;
              } else {
                this.patientMobileNumber = '';
              }
              this.patientLatitude = this.salesOrder.patientInfo.crmLatitude;
              this.patientLongitude = this.salesOrder.patientInfo.crmLongitude;
              if (this.appointment.schIsBillingAddress) this.patientAddress = this.salesOrder.patientInfo.crmPatientAddress;
              else this.patientAddress = this.salesOrder.patientInfo.crmPatientDeliveryAddress;

              this.patientTimezone = new TimezonePipe(this.webStorageService).transform(this.appointment?.appointmentDetailInfo.crmPatientTimeZone);
              if (this.appointment.schAppointmentType != 'Telehealth') {
                this.therapistName =
                  this.appointment?.appointmentDetailInfo?.therapistInfo?.appUserFname + ' ' + this.appointment?.appointmentDetailInfo?.therapistInfo?.appUserLname;
                this.facilityName = this.appointment?.appointmentDetailInfo?.facilityInfo?.crmFacilityName;
                this.facilityAddress = this.appointment?.appointmentDetailInfo?.facilityInfo?.crmFacilityAddress;
                this.facilityLatitude = this.appointment?.appointmentDetailInfo?.facilityInfo?.crmFacilityLatitude;
                this.facilityLongitude = this.appointment?.appointmentDetailInfo?.facilityInfo?.crmFacilityLongitude;                
                
                if(this.appointment?.distance){
                  this.distance = this.appointment.distance + ' miles away';
                }

                setTimeout(() => {
                  this.initMap();
                }, 200);
                this.markers = [
                  {
                    lat: this.facilityLatitude,
                    lng: this.facilityLongitude,
                    label: this.facilityName,
                    draggable: false,
                    type: 'F',
                    address: this.facilityAddress
                  },
                  {
                    lat: this.patientLatitude,
                    lng: this.patientLongitude,
                    label: this.patientName,
                    draggable: false,
                    type: 'P',
                    address: this.patientAddress
                  }
                ];
              }
              this.schAppointmentId = AppoinmentId;
              this.dueAmount = this.appointment?.salesOrderInfo?.amountDue;
              this.appointmentTitle = this.appointment?.schAppointmentTypeDisplayName;
              let onlineAppointmentTypeResponseModel = this.webStorageService.getOnlineAppointmentTypeNames();
              if (onlineAppointmentTypeResponseModel?.length > 0) {
                if (this.appointment?.schAppointmentTypeDisplayName == 'Facility Visit') {
                  let FacilityVisit = onlineAppointmentTypeResponseModel.find((x) => x.crmOnlineAppointmentType == 'FacilityVisit');
                  if (FacilityVisit) {
                    this.appointmentTitle = FacilityVisit.crmOnlineAppointmentTitle;
                  }
                }
              }
            }
          }
          this.loading = false;
          this.loadingCustom = false;
        });
      })
      .catch((httpResponseError) => {
        this.loading = false;
        this.loadingCustom = false;
        this.showErrorMessage(httpResponseError.message);
      });
  }

  private async GetPatientSalesOrdersSetings() {
    await this.patientSettingsService
      .getPatientSalesOrdersSetings()
      .pipe(
        takeUntil(this.unsubscriber),
        finalize(() => (this.loading = false))
      )
      .toPromise()
      .then((result) => {
        this.processResult<CustomSettingsResponseModel>(result, () => {
          if (result.isSuccess) {
            if (result.responseModel) {
              this.webStorageService.storePatientSalesOrderSettings(result.responseModel);
              this.settingResult = this.webStorageService.getPatientSalesOrderSettings();
            }
          }
        });
      });
  }

  clickedMarker(label: string, index: number) {
    console.log(`clicked the marker: ${label || index}`);
  }

  markerDragEnd(m: marker, $event: MouseEvent) { }

  private async getDMENumber() {
    if (!this.salesOrderData) {
      return;
    }
    await this.patientSettingsService
      .getAllBranchNumbers(this.salesOrderData.crmBranchId)
      .pipe(
        takeUntil(this.unsubscriber),
        finalize(() => (this.loading = false))
      )
      .toPromise()
      .then((result) => {
        this.processResult<BranchNumbersResponseModel>(result, () => {
          if (result.isSuccess) {
            if (result.responseModel) {
              this.DMENumber = result.responseModel.dmephoneNumber;
              this.webStorageService.saveDMENumber(this.DMENumber);
              var branchInfoContactModel = new BranchInfoContactModel();
              if (this.webStorageService.getBranchContactInfoById()) {
                this.webStorageService.deleteBranchContactInfoById();
              }
              branchInfoContactModel.branchid = this.salesOrderData.crmBranchId;
              branchInfoContactModel.DMEEmail = result?.responseModel?.dmeemail;
              branchInfoContactModel.DMENumber = result?.responseModel?.dmephoneNumber;
              branchInfoContactModel.DMEBranch = result?.responseModel?.branch?.crmBranchName;
              this.webStorageService.storeBranchContactInfo(branchInfoContactModel);
            }
          }
        });
      });
  }
}
